import { createPageTableSchema } from '@state/_shared/tableComponentStateSchema';

// Define the specific structure for a row in the buy lego table (Salvation Army listings)
const buyLegoRowSchema = {
    type: 'object',
    properties: {
        // Core identifier
        id: { type: 'string', default: '' },
        
        // Listing details
        title: { type: 'string', default: '' },
        description: { type: 'string', default: '' },
        current_price: { type: 'number', default: 0.00 },
        buy_it_now_price: { type: ['number', 'null'], default: null },
        
        // Bidding information
        bid_count: { type: 'number', default: 0 },
        highest_bidder: { type: ['string', 'null'], default: null },
        
        // Timing
        end_time: { type: ['string', 'null'], default: null },
        time_remaining: { type: ['string', 'null'], default: null },
        
        // Location and shipping
        location: { type: ['string', 'null'], default: null },
        shipping_rates: { 
            type: 'array',
            default: [],
            items: {
                type: 'object',
                properties: {
                    method: { type: 'string' },
                    cost: { type: 'number' },
                    time: { type: 'string' }
                }
            }
        },
        
        // Images and links
        image_url: { type: ['string', 'null'], default: null },
        listing_url: { type: ['string', 'null'], default: null },
        
        // Status flags
        is_auction: { type: 'boolean', default: true },
        has_buy_it_now: { type: 'boolean', default: false },
        
        // Timestamps
        created_at: { type: ['string', 'null'], default: null },
        updated_at: { type: ['string', 'null'], default: null }
    }
};

// Define the possible action states for rows in this specific table
const buyLegoRowActions = {
    isRefreshing: { type: 'boolean', default: false },
    isCalculatingShipping: { type: 'boolean', default: false },
    isUpdating: { type: 'boolean', default: false }
};

// Create the table schema specific to this page
const pageTableSchema = createPageTableSchema(buyLegoRowSchema, buyLegoRowActions);

// Schema definition for buy lego page state
export const buyLegoPageStateSchema = {
    // Table State (using the shared schema)
    table: pageTableSchema,
    
    // Salvation Army specific state
    salvationArmy: {
        type: 'object',
        properties: {
            listings: {
                type: 'array',
                items: buyLegoRowSchema,
                default: [],
                description: 'Current Salvation Army listings'
            },
            lastQueryTime: {
                type: ['string', 'null'],
                default: null,
                persist: true,
                description: 'Timestamp of last query to Salvation Army'
            },
            isQuerying: {
                type: 'boolean',
                default: false,
                description: 'Whether currently querying Salvation Army'
            }
        }
    },
    
    // Filter States
    filters: {
        type: 'object',
        properties: {
            showOnlyMyBids: {
                type: 'boolean',
                default: false,
                persist: true,
                description: 'Show only listings where user has placed bids'
            }
        }
    },
    
    // Loading States
    loadingStates: {
        type: 'object',
        properties: {
            refreshingListingIds: {
                type: 'array',
                items: { type: ['string', 'number'] },
                default: [],
                description: 'IDs of listings currently being refreshed'
            },
            loadingShippingIds: {
                type: 'array',
                items: { type: ['string', 'number'] },
                default: [],
                description: 'IDs of listings currently calculating shipping'
            }
        }
    },
    
    // User preferences
    preferences: {
        type: 'object',
        properties: {
            autoRefreshInterval: {
                type: 'number',
                default: 300000, // 5 minutes
                persist: true,
                description: 'Auto refresh interval in milliseconds'
            },
            enableAutoRefresh: {
                type: 'boolean',
                default: false,
                persist: true,
                description: 'Whether to auto-refresh listings'
            }
        }
    }
};

export default buyLegoPageStateSchema;